/**
 * Bridges the axios-level access token — refreshed either reactively by
 * privateClient.ts's 401 interceptor or proactively by SessionKeepAlive —
 * into Redux. Without this, state.auth.token (read by ProtectedRoute /
 * PublicRoute) would stay pinned to the token issued at login forever,
 * so any later successful refresh would go unnoticed and the *next*
 * expiry check would still see the original (by-then-expired) token.
 *
 * Kept as a standalone module, not an import of the store — same
 * circular-dependency reason documented in csrfToken.ts: privateClient.ts
 * is used deep inside the module graph the store itself depends on
 * (store -> rootReducer -> authSlice -> authService -> privateClient), so
 * privateClient.ts cannot import the store directly.
 */

let listener: ((token: string) => void) | null = null;

/** Called once from main.tsx, after the store exists, to wire this up. */
export function onTokenRefreshed(fn: (token: string) => void) {
  listener = fn;
}

/** Called by privateClient.ts whenever it obtains a fresh access token. */
export function notifyTokenRefreshed(token: string) {
  listener?.(token);
}
